module.exports = __webpack_public_path__ + "img/29.d99406de.png";